import { UPDATE_USER_DATA, UserState, UserActionTypes } from "./types";

export function updateUser(userState: UserState): UserActionTypes {
    return {
        type: UPDATE_USER_DATA,
        payload: userState
    };
}